import { ButtonActionType } from '@finxone-platform/shared/sys-config-types';

export function isAlertTypeApplicable(action: ButtonActionType | undefined): boolean {
  const actionsThatShowAlertType: ButtonActionType[] = [
    ButtonActionType.SUBMIT_USER_PROFILE_UPDATE,
    // Add more actions here in the future
  ];

  return action ? actionsThatShowAlertType.includes(action) : false;
}

export function isSuccessAlertTypeOption(action: ButtonActionType | undefined): {
  label: string;
  value: string;
}[] {
  if (!action) return [];

  switch (action) {
    case ButtonActionType.SUBMIT_USER_PROFILE_UPDATE:
      return [{ label: 'marketing_preference_updated', value: 'marketin_preference_updated' }];
    // Add more actions options here in the future
    default:
      return [];
  }
}

export function isErrorAlertTypeOption(action: ButtonActionType | undefined): {
  label: string;
  value: string;
}[] {
  if (!action) return [];

  switch (action) {
    case ButtonActionType.SUBMIT_USER_PROFILE_UPDATE:
      return [{ label: 'profile_update_lockout_days', value: 'profile_update_lockout_days' }];
    // Add more actions options here in the future
    default:
      return [];
  }
}
